import en from "./lang/en"
import fr from "./lang/fr"
import zh from "./lang/zh"
import ar from "./lang/ar"
import de from "./lang/de";
import es from "./lang/es";
import sk from "./lang/sk";
import it from "./lang/it";

export const langOptions = {
    'ar': 'العربية',
    'de': 'Deutsch',
    'en': 'English',
    'es': 'Español',
    'fr': 'Français',
    'it': 'Italy',
    'sk': 'Slovak',
    'zh': '简体中文',
}

export const langPackage = {
    'ar': ar,
    'de': de,
    'en': en,
    'es': es,
    'fr': fr,
    'it': it,
    'sk': sk,
    'zh': zh,
}
